import useQueryClient from 'hooks/react-query/useClientQuery';
import useMutation from 'hooks/react-query/useMutation';
import { grantIntervatAccessToWorkspace } from 'api/v2/users/beFinances';
import { getBEFinSessionQueryKey } from 'hooks/useBEFinSession/getBEFinSessionQueryKey';
import { useTranslation } from 'react-i18next';
import { UserCacheKeys } from 'types/cacheKeys.types';
import showToast from 'utils/toast';

type Options = {
  /** Runs after invalidating BEFinSession and UserWorkspaces, before the success toast. */
  onAfterSuccess?: () => void;
};

/**
 * Shared mutation for granting Intervat access to a workspace: invalidates session/workspace
 * queries, optional callback, then success toast (and error toast on failure).
 */
const useGrantIntervatAccessToWorkspace = (options?: Options) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { onAfterSuccess } = options ?? {};

  return useMutation(grantIntervatAccessToWorkspace, {
    onSuccess: () => {
      queryClient.invalidateQueries(getBEFinSessionQueryKey());
      queryClient.invalidateQueries([UserCacheKeys.UserWorkspaces]);
      onAfterSuccess?.();
      showToast({
        variant: 'success',
        title: t('taxes.intervat_grant_modal.access_granted_until_revoked'),
      });
    },
    onError: () => {
      showToast({
        variant: 'error',
        title: t('something_went_wrong'),
      });
    },
  });
};

export default useGrantIntervatAccessToWorkspace;
